var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0794 12.8764C10.0934 12.8941 10.1113 12.9084 10.1317 12.9182C10.1521 12.928 10.1745 12.9331 10.1973 12.9331C10.22 12.9331 10.2424 12.928 10.2628 12.9182C10.2833 12.9084 10.3012 12.8941 10.3152 12.8764L12.4114 10.2598C12.4882 10.1638 12.4189 10.0216 12.2935 10.0216H10.9066V3.77273C10.9066 3.69148 10.8392 3.625 10.7569 3.625H9.6339C9.55154 3.625 9.48416 3.69148 9.48416 3.77273V10.0197H8.10101C7.97561 10.0197 7.90636 10.1619 7.98309 10.258L10.0794 12.8764ZM17.0475 12.2301H15.9245C15.8422 12.2301 15.7748 12.2966 15.7748 12.3778V15.2216H4.61973V12.3778C4.61973 12.2966 4.55235 12.2301 4.46999 12.2301H3.347C3.26465 12.2301 3.19727 12.2966 3.19727 12.3778V16.0341C3.19727 16.3609 3.46491 16.625 3.7962 16.625H16.5983C16.9296 16.625 17.1973 16.3609 17.1973 16.0341V12.3778C17.1973 12.2966 17.1299 12.2301 17.0475 12.2301Z",
    fill: "#FCFAFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.a9b17b8e7bae6385231299681da8fb74.svg";
export { ForwardRef as ReactComponent };